import React from 'react';

const TextMarquee = () => {
  const text = 'Повышение маржи на счет снижения рекламных расходов в три раза 👇';
  // Repeat text enough times for seamless scrolling
  const repeated = Array(8).fill(text);

  return (
    <>
      <style>{`
        @keyframes textMarqueeScroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-25%);
          }
        }

        @media (max-width: 768px) {
          .text-marquee-section { padding: 14px 0 !important; }
          .text-marquee-track { gap: 30px !important; }
          .text-marquee-item { font-size: 13px !important; }
        }

        @media (max-width: 480px) {
          .text-marquee-section { padding: 10px 0 !important; }
          .text-marquee-track { gap: 20px !important; }
          .text-marquee-item { font-size: 12px !important; }
        }
      `}</style>

      <section
        className="text-marquee-section"
        style={{
          background: 'linear-gradient(135deg, #F8F9FC 0%, #EEF1F8 25%, #F5F3FA 50%, #EDF5F8 75%, #F8F9FC 100%)',
          padding: '20px 0',
          overflow: 'hidden',
          borderTop: '1px solid rgba(0, 0, 0, 0.04)',
          borderBottom: '1px solid rgba(0, 0, 0, 0.04)',
        }}
      >
        <div
          className="text-marquee-track"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '60px',
            animation: 'textMarqueeScroll 20s linear infinite',
            width: 'max-content',
          }}
        >
          {repeated.map((item, i) => (
            <span
              key={i}
              className="text-marquee-item"
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '16px',
                fontWeight: 600,
                color: '#0F0F1A',
                whiteSpace: 'nowrap',
                textTransform: 'uppercase',
                letterSpacing: '0.04em',
                flexShrink: 0,
              }}
            >
              {item}
            </span>
          ))}
        </div>
      </section>
    </>
  );
};

export default TextMarquee;
